import { createSelector } from 'reselect'
// import { List } from 'immutable'

const projectInformationSelector = state => state.get('projectInformation')

export const getIsFetching = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationGet.isFetching
    || projectInformation.projectInformationList.isFetching
    || projectInformation.projectInformationEdit.isFetching
    || projectInformation.projectInformationChangeStatus.isFetching
    || projectInformation.projectInformationCreate.isFetching
    || projectInformation.projectInformationAutoAdd.isFetching
    || projectInformation.projectInformationAutoFill.isFetching
    || projectInformation.projectInformationSubmit.isFetching
    || projectInformation.projectInformationApprove.isFetching
    || projectInformation.projectInformationGetSnapshot.isFetching
    || projectInformation.projectInformationSaveSnapshot.isFetching
    || projectInformation.projectInformationExport.isFetching
  }
)
export const getIsFetchingList = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationList.isFetching
  }
)
export const getIsFetchingEdit = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationEdit.isFetching
  }
)

export const getProjectInformationData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationList
  }
)
export const getProjectInformationByIDData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationGet
  }
)
export const createProjectInformationData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationCreate
  }
)
export const editProjectInformationData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationEdit
  }
)
export const autoAddResourcesData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationAutoAdd
  }
)
export const autoFillManDaysData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationAutoFill
  }
)
export const changeStatusProjectInformationData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationChangeStatus
  }
)
export const submitProjectInformationData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationSubmit
  }
)
export const checkSubmitProjectInformationData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationCheckSubmit
  }
)
export const approveProjectInformationData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationApprove
  }
)
export const isOpenManual = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationManual.isOpen
  }
)
export const getTypeManual = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationManual.type
  }
)
export const getExportURL = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationExport.url
  }
)
export const getSnapshotData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationGetSnapshot
  }
)
export const saveSnapshotData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationSaveSnapshot
  }
)
export const getCRType = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationGet.crType || []
  }
)
export const getPPSLatestSubmittedDate = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationGet.ppsLatestSubmittedDate || ''
  }
)
export const getCanEditAllocation = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformationGet.canEditAllocation
  }
)
export const getRevenuePlanningData = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.revenuePlanning.revenueTable
  }
)
export const getIsEditRevenuePlanning = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.revenuePlanning.isEdit
  }
)
export const getIncompletedRevenue = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.revenuePlanning.incompletedList
  }
)
export const getProjectInformation = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return projectInformation.projectInformation
  }
)
export const redirectProject = createSelector(
  projectInformationSelector,
  projectInformationImmutable => {
    const projectInformation = projectInformationImmutable.toJS()
    return ({
      redirect: (projectInformation.projectInformationGet.redirect
      || projectInformation.projectInformationList.redirect
      || projectInformation.projectInformationEdit.redirect
      || projectInformation.projectInformationChangeStatus.redirect
      || projectInformation.projectInformationCreate.redirect
      || projectInformation.projectInformationAutoAdd.redirect
      || projectInformation.projectInformationAutoFill.redirect
      || projectInformation.projectInformationSubmit.redirect
      || projectInformation.projectInformationApprove.redirect
      || projectInformation.projectInformationGetSnapshot.redirect
      || projectInformation.projectInformationSaveSnapshot.redirect
      || projectInformation.projectInformationExport.redirect),
      isAuthenticated: (projectInformation.projectInformationGet.isAuthenticated
      || projectInformation.projectInformationList.isAuthenticated
      || projectInformation.projectInformationEdit.isAuthenticated
      || projectInformation.projectInformationChangeStatus.isAuthenticated
      || projectInformation.projectInformationCreate.isAuthenticated
      || projectInformation.projectInformationAutoAdd.isAuthenticated
      || projectInformation.projectInformationAutoFill.isAuthenticated
      || projectInformation.projectInformationSubmit.isAuthenticated
      || projectInformation.projectInformationApprove.isAuthenticated
      || projectInformation.projectInformationGetSnapshot.isAuthenticated
      || projectInformation.projectInformationSaveSnapshot.isAuthenticated
      || projectInformation.projectInformationExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/project-information/project-information-selector.js